import { openModal } from '@core/components/ModalStack';
import { CancelSubscriptionModalProps } from './CancelSubscriptionModal';

export async function openCancelSubscriptionModal(props: CancelSubscriptionModalProps) {
  const { CancelSubscriptionModal } = await import('./CancelSubscriptionModal');

  openModal(CancelSubscriptionModal, props);
}
